import { jsx as _jsx } from "react/jsx-runtime";
import { STANDARD_SPACING } from "../config";
export default function FormSubmitContainer(props) {
    return (_jsx("div", { className: "hstack gap-" + STANDARD_SPACING, children: props.children }));
}
